import { createContext, useContext, useState } from "react"
import { useStore } from "zustand"

import type { TFormTabsStore } from "./form_tab.store"
import { createFormTabsStore } from "./form_tab.store"

const FormTabsStoreContext = createContext<ReturnType<
  typeof createFormTabsStore
> | null>(null)

interface IFormTabsStoreProviderProps extends React.PropsWithChildren {
  onSubmit?: () => void
}

export const FormTabsStoreProvider: React.FC<IFormTabsStoreProviderProps> = ({
  children,
  onSubmit = () => {
    /* empty */
  },
}) => {
  const [store] = useState(() => createFormTabsStore({ onSubmit }))

  return (
    <FormTabsStoreContext.Provider value={store}>
      {children}
    </FormTabsStoreContext.Provider>
  )
}

export const useFormTabsStore = <U,>(
  selector: (state: TFormTabsStore) => U,
) => {
  const store = useContext(FormTabsStoreContext)

  if (store === null) {
    throw new Error(
      "useFormTabsStore must be used within FormTabsStoreProvider",
    )
  }

  return useStore(store, selector)
}
